import { getBadgeStyles, getIconStyles } from '../../utils';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Badge: ComponentStyleConfig = {
  parts: ['BadgeContainer', 'Tooltip', 'BadgeDiv', 'Icon', 'Content'],
  baseStyle: (props: StyleFunctionProps) => {
    const { badgeSize = 'sm' } = props;
    return {
      BadgeContainer: {},
      Tooltip: {},
      BadgeDiv: {
        flexShrink: 0,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 'full',
        bg: 'primary',
        color: mode('white', 'gray.400')(props),
        fontSize: badgeSize,
        ...getBadgeStyles(badgeSize),
      },
      Icon: {
        ml: -1,
        mr: 1.5,
        ...getIconStyles(badgeSize),
      },
      Content: {
        whiteSpace: 'nowrap',
      },
    };
  },
};

export default Badge;
